// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/collection-driver/collection-driver';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/powertools-filter/powertools-filter';

import 'sections/page-header/page-header';
import 'sections/footer/footer';

// Styles
import './_collection.scss';

import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, Thumbs } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';


// -------------------------------------
// Hooks
// -------------------------------------
function handleFeaturePanelSlides(swiperEl) {
    swiperEl.slides.forEach(function (slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function (e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function () {
    $(".carousel--filter-buttons").each(function (index, element) {
        var $this = $(this);

        // Generate unique class for each feature card slider
        $this.addClass("filter-buttons-instance-" + index);

        // Initialize feature card slider based on the unique classes generated above.
        var swiper = new Swiper(".filter-buttons-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            draggable: true,
            grabCursor: true,
            a11y: false,
            touchRatio: 1,           // Ensures touch sensitivity
            simulateTouch: true,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            centerInsufficientSlides: false,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 1000,
                    spaceBetween: 20
                }
            },
        });

        swiper.slides.forEach(function (slide, index) {
            slide.addEventListener('focus', function (e) {
                swiper.slideTo(index);
            })
        });
    });
});
